<span class="text">
    <ng-content></ng-content>
</span>
